import { render, staticRenderFns } from "./SocialReviews.vue?vue&type=template&id=b7b7f0b2&scoped=true&"
import script from "./SocialReviews.vue?vue&type=script&lang=js&"
export * from "./SocialReviews.vue?vue&type=script&lang=js&"
import style0 from "./SocialReviews.vue?vue&type=style&index=0&id=b7b7f0b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b7f0b2",
  null
  
)

export default component.exports